import { ProgressBar } from './progress-bar';
import { ProgressCircleGroups, ProgressCircle } from './progress-circle';
export default {
    Bar: ProgressBar,
    CircleGroups: ProgressCircleGroups,
    Circle: ProgressCircle,
};
